import React from "react";

const OnboardingCopilotIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 160" width="1em" height="1em" stroke="currentColor" strokeWidth="11" strokeLinecap="round" className={className}>
      <circle fill="none" cx="53.48" cy="44.41" r="29.67"/>
      <circle fill="none" cx="116.6" cy="109.6" r="35.65"/>
      <polyline fill="none" points="101.06 109.31 112 120.25 132.14 98.96" strokeWidth="9"/>
      <path fill="none" d="M65.83,91.29h-20.54c-7.14.07-10.61,1.63-15.07,3.18-11.56,4.01-19.67,15.91-22.37,33.86,0,0-2.46,15.65,15.96,16.93h54.1"/>
    </svg>
  );
};

export default OnboardingCopilotIcon;
